import { render, staticRenderFns } from "./billRatio.vue?vue&type=template&id=6706e87c&"
import script from "./billRatio.vue?vue&type=script&lang=js&"
export * from "./billRatio.vue?vue&type=script&lang=js&"
import style0 from "./billRatio.vue?vue&type=style&index=0&id=6706e87c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports